<template>
    <div class="cz2__review-views">
        <div class="cz2__review-views--wrapper">
            <span class="cz2__sr-only">
                {{ $t('SR_ACTIVATING') }}
            </span>

            <button
                :class="[
                    {
                        'cz2__review-views__view--active': view === boxView,
                        'cz2__review-views__view--box': boxPreviewImage == null,
                    },
                    isTwoPack ? 'cz2__review-views__view--box-pack' : 'cz2__review-views__view--box-single',
                ]"
                type="button"
                @click="selectView(boxView)"
                :aria-current="view === boxView"
                aria-label="View pop in box"
                class="cz2__review-views__view"
            >
                <span
                    class="cz2__review-views__view-image"
                    :style="{
                        backgroundImage: boxPreviewImage ? `url(${boxPreviewImage})` : null,
                    }"
                />

                <span>
                    {{ $t('REVIEW_IN_BOX') }}
                </span>
            </button>

            <span class="cz2__review-views--divider" />

            <button
                :class="[
                    {
                        'cz2__review-views__view--active': view === popView,
                        'cz2__review-views__view--pop': popPreviewImage == null,
                    },
                    isTwoPack ? 'cz2__review-views__view--pop-pack' : 'cz2__review-views__view--pop-single',
                ]"
                type="button"
                @click="selectView(popView)"
                :aria-current="view === popView"
                aria-label="View pop out of box"
                class="cz2__review-views__view"
            >
                <span
                    class="cz2__review-views__view-image"
                    :style="{
                        backgroundImage: popPreviewImage ? `url(${popPreviewImage})` : null,
                    }"
                />

                <span>
                    {{ $t('REVIEW_OUT_OF_BOX') }}
                </span>
            </button>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps-options__review {
            .cz2__review-views {
                text-align: center;
                color: white;
                @include font(h3);
                font-size: 13px;
            }

            .cz2__review-views--wrapper {
                display: flex;
                flex-direction: row;
                gap: 24px;
                align-items: center;
            }

            .cz2__review-views--divider {
                width: 2px;
                height: 48px;
                background-color: white;
                border-radius: 99px;
            }

            .cz2__review-views__view {
                flex: 0 0 auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                gap: 6px;

                position: relative;

                width: 63px;
                height: 69px;

                color: white;

                &:focus-visible {
                    outline: none;

                    border: 1px solid white;
                }

                .cz2__review-views__view-image {
                    flex: none;
                    width: 100%;
                    height: 48px;

                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                &.cz2__review-views__view--pop {
                    .cz2__review-views__view-image {
                        background: transparent url(../assets/images/figure@2x.png) no-repeat center/contain;
                    }
                }

                &.cz2__review-views__view--box {
                    .cz2__review-views__view-image {
                        background: transparent url(../assets/images/box@2x.png) no-repeat center/contain;
                    }
                }

                &:not(.cz2__review-views__view--active) {
                    opacity: 50%;
                }
            }

            @include respond-above(md) {
                .cz2__review-views--wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    align-items: center;
                }

                .cz2__review-views--divider {
                    width: 48px;
                    height: 2px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__review-views {
            position: absolute;
            bottom: 160.27px;
            width: var(--vw100, 100vw);

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            right: 0;
            gap: 16px;
        }

        .cz2__review-views__view {
            &.cz2__review-views__view--pop-single {
                transform: scale(2.3) translate(-5px, 0);
            }

            &.cz2__review-views__view--box-single {
                transform: scale(2.3) translate(+10px, 0);
            }

            &.cz2__review-views__view--pop-pack {
                transform: scale(2.3) translate(-20px, 0);
            }

            &.cz2__review-views__view--box-pack {
                transform: scale(2.3) translate(+20px, 0);
            }
        }

        .cz2__review-views--divider {
            margin-left: 24px;
            margin-right: 24px;
        }
    }
</style>

<script>
    export default {
        data() {
            const { isTwoPack } = this.$store.getters;

            return {
                view: isTwoPack ? 'BoxFarPack' : 'BoxFar',
            };
        },

        computed: {
            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            popPreviewImage() {
                return this.$store.state.customizer.popPreviewImage;
            },

            boxPreviewImage() {
                return this.$store.state.customizer.boxPreviewImage;
            },

            popView() {
                return this.isTwoPack ? 'MainMiniPack' : 'Main Mini';
            },

            boxView() {
                return this.isTwoPack ? 'BoxFarPack' : 'BoxFar';
            },
        },

        methods: {
            selectView(view) {
                this.view = view;
                this.$store.dispatch('setPreferredView', view);
            },
        },
    };
</script>
